export default __webpack_public_path__ + "static/media/c1.bb0818e9.svg";